import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Mixpanel from 'utils/mixpanelService';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeSelectAuth } from 'containers/Auth/selectors';
import LinkedInIcon from 'components/SocialIcons/linkedin.svg';
import InstagramIcon from 'components/SocialIcons/instagram.svg';
import TwitterIcon from 'components/SocialIcons/twitter.svg';
import FacebookIcon from 'components/SocialIcons/facebook.svg';
import { isBot } from 'utils/stringUtils';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  icon: {
    marginLeft: 5,
    marginRight: 5,
    height: 18,
    outline: 'none',
    cursor: 'pointer',
    filter: 'grayscale(1)',
    '&:hover': {
      filter: 'grayscale(0)',
    },
  },
});

const IconLinks = [
  {
    link: 'https://www.facebook.com/CredibleMind',
    icon: FacebookIcon,
    social: 'Facebook',
  },
  {
    link: 'https://instagram.com/crediblemind',
    icon: InstagramIcon,
    social: 'Instagram',
  },
  {
    link: 'https://twitter.com/crediblemind',
    icon: TwitterIcon,
    social: 'Twitter',
  },
  {
    link: 'https://linkedin.com/company/crediblemind',
    icon: LinkedInIcon,
    social: 'LinkedIn',
  },
];
function SocialLinks({ classes, location }) {
  const redirect = social => {
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Social Link - Clicked', {
      exitPage: social,
      page: finalPageName,
    });
  };
  const bot = isBot();
  return (
    <Grid item xs={12} className={classes.root}>
      {IconLinks.map(({ link, icon, social }) => (
        <a
          rel="noopener noreferrer"
          href={link}
          target="_blank"
          onClick={() => redirect(social)}
          key={link}
        >
          {!bot && (
            <LazyLoadImage
              src={icon}
              alt="Social Links"
              className={classes.icon}
            />
          )}
          {bot && social}
        </a>
      ))}
    </Grid>
  );
}

SocialLinks.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  auth: makeSelectAuth(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withRouter,
  withConnect,
  withStyles(styles),
)(SocialLinks);
